import axios from "axios";
import { PlanningRace } from "../interfaces/planning";

export function getPlanning(season: number = 0, team: number = 0) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning';
    const params = [];
    if (season != 0) {
        params.push('season=' + season);
    }
    if (team != 0) {
        params.push('team=' + team);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getAthletePlanning(athlete: number, start_date?: string, end_date?: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-planning/' + athlete;
    const params = [];
    if (start_date && end_date) {
        params.push('start_date=' + encodeURIComponent(start_date));
        params.push('end_date=' + encodeURIComponent(end_date));
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getCoachPlanning(coach: number, start_date?: string, end_date?: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning/' + coach;
    const params = [];
    if (start_date && end_date) {
        params.push('start_date=' + encodeURIComponent(start_date));
        params.push('end_date=' + encodeURIComponent(end_date));
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function updatePlanningWeek(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-week';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updatePlanningDay(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-day';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updatePlanningDaySession(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-day-session';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function getPlanningSession(season: number, team: number, day: string, moment: string, session: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-session';
    const params = [];
    if (season != 0) {
        params.push('season=' + encodeURIComponent(season));
    }
    if (team != 0) {
        params.push('team=' + encodeURIComponent(team));
    }
    if (day != '') {
        params.push('day=' + encodeURIComponent(day));
    }
    if (moment != '') {
        params.push('moment=' + encodeURIComponent(moment));
    }
    if (session != '') {
        params.push('session=' + encodeURIComponent(session));
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers });
}

export function deletePlanningDaySession(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-day-session';
    return axios.delete(endpointUrl, { headers: headers, data: JSON.stringify(body_obj) });
}

export function getAthletePlanningFeedback(athlete: number, day: string, day_moment: string, day_moment_session: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-planning-day-feedback';
    const params = [];
    if (athlete != 0) {
        params.push('athlete=' + athlete);
    }
    if (day != '') {
        params.push('day=' + day);
    }
    if (day_moment != '') {
        params.push('day_moment=' + day_moment);
    }
    if (day_moment_session != '') {
        params.push('day_moment_session=' + day_moment_session);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function updateAthletePlanningFeedback(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-planning-day-feedback';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function getCoachPlanningResults(team: number, day: string, day_moment: string, day_moment_session: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-results';
    const params = [];
    if (team != 0) {
        params.push('team=' + team);
    }
    if (day != '') {
        params.push('day=' + day);
    }
    if (day_moment != '') {
        params.push('day_moment=' + day_moment);
    }
    if (day_moment_session != '') {
        params.push('day_moment_session=' + day_moment_session);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function updateCoachPlanningResults(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-results';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function getCoachPlanningMonitoringList(team: number, day: string, day_moment: string, day_moment_session: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-list';
    const params = [];
    if (team != 0) {
        params.push('team=' + team);
    }
    if (day != '') {
        params.push('day=' + day);
    }
    if (day_moment != '') {
        params.push('day_moment=' + day_moment);
    }
    if (day_moment_session != '') {
        params.push('day_moment_session=' + day_moment_session);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getCoachPlanningMonitoring(team: number, day: string, day_moment: string, day_moment_session: string, monitoring_id?: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring';
    const params = [];

    // Prefer monitoring_id if provided
    if (monitoring_id) {
        params.push('monitoring_id=' + monitoring_id);
    } else {
        // Legacy parameters
        if (team != 0) {
            params.push('team=' + team);
        }
        if (day != '') {
            params.push('day=' + day);
        }
        if (day_moment != '') {
            params.push('day_moment=' + day_moment);
        }
        if (day_moment_session != '') {
            params.push('day_moment_session=' + day_moment_session);
        }
    }

    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function updateCoachPlanningMonitorStart(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-start';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCoachPlanningMonitorFinish(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-finish';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCoachPlanningMonitorReset(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-reset';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCoachPlanningMonitorShovelfuls(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-shovelfuls';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCoachPlanningMonitorLap(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-lap';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCoachPlanningMonitorComments(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-comments';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCoachPlanningMonitorManual(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-manual';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCoachPlanningMonitorEvent(event_id: number, event_time: string, event_value?: string | null) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-event-update';
    const body: any = { event_id, event_time };
    if (event_value !== undefined) {
        body.event_value = event_value;
    }
    return axios.post(endpointUrl, JSON.stringify(body), { headers: headers });
}

export function deleteCoachPlanningMonitorEvent(event_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-event-delete';
    return axios.post(endpointUrl, JSON.stringify({ event_id }), { headers: headers });
}

export function getMonitoringHistory(team: number = 0, athlete: number = 0, date_from: string = '', date_to: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/monitoring-history';
    const params = [];
    if (team != 0) {
        params.push('team=' + team);
    }
    if (athlete != 0) {
        params.push('athlete=' + athlete);
    }
    if (date_from) {
        params.push('date_from=' + date_from);
    }
    if (date_to) {
        params.push('date_to=' + date_to);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers });
}

export function deleteCoachPlanningMonitoring(monitoring_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/coach-planning-day-monitoring-delete';
    return axios.post(endpointUrl, JSON.stringify({ monitoring_id }), { headers: headers });
}

export function getPlanningReports(season: number = 0, team: number = 0, month: number = 0, week: number = 0, day: number = 0, athlete: number = 0) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-reports';
    const params = [];
    if (season != 0) {
        params.push('season=' + season);
    }
    if (team != 0) {
        params.push('team=' + team);
    }
    if (month != 0) {
        params.push('month=' + month);
    }
    if (week != 0) {
        params.push('week=' + week);
    }
    if (day != 0) {
        params.push('day=' + day);
    }
    if (athlete != 0) {
        params.push('athlete=' + athlete);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function updatePlanningPeriodicity(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-periodicity';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

/**
 * ========================================
 * PLANNING RACE API FUNCTIONS
 * ========================================
 * These functions manage races/competitions within the planning system.
 * Races are associated with specific planning weeks and displayed in the
 * Timeline section of the planning table.
 *
 * Note: The main getPlanning() function now returns races integrated
 * within each week object, so getPlanningRacesBySeason is rarely needed.
 */

/**
 * Retrieves all races for a given season
 * @param season_id - The season ID to fetch races for
 * @returns Promise with array of PlanningRace objects
 */
export function getPlanningRacesBySeason(season_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-race/season/' + season_id;
    return axios.get(endpointUrl, { headers: headers });
}

/**
 * Retrieves all races for a specific planning week
 * @param planning_week_id - The planning week ID to fetch races for
 * @returns Promise with array of PlanningRace objects
 */
export function getPlanningRacesByWeek(planning_week_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-race/week/' + planning_week_id;
    return axios.get(endpointUrl, { headers: headers });
}

/**
 * Creates a new race/competition in the planning system
 * @param race - PlanningRace object with planning_week_id, title, and optional description
 * @returns Promise with response containing the created race ID
 */
export function createPlanningRace(race: PlanningRace) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-race';
    return axios.post(endpointUrl, JSON.stringify(race), { headers: headers });
}

/**
 * Updates an existing race/competition
 * @param race - PlanningRace object with id and fields to update
 * @returns Promise with response containing updated race data
 */
export function updatePlanningRace(race: PlanningRace) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-race';
    return axios.patch(endpointUrl, JSON.stringify(race), { headers: headers });
}

/**
 * Deletes a race/competition from the planning system
 * @param id - The race ID to delete
 * @returns Promise with deletion confirmation
 */
export function deletePlanningRace(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-race/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

/**
 * ========================================
 * PLANNING WEEK CONTENT API FUNCTIONS
 * ========================================
 * These functions manage the content distribution for planning weeks.
 * Content includes field-specific values with colors and observations.
 */

/**
 * Retrieves all content for a specific planning week
 * @param planning_week_id - The planning week ID to fetch content for
 * @returns Promise with array of content objects
 */
export function getPlanningWeekContent(planning_week_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-week-content/' + planning_week_id;
    return axios.get(endpointUrl, { headers: headers });
}

/**
 * Creates a new content entry for a planning week
 * @param body_obj - Object with planning_week_id, field, value, color, observations
 * @returns Promise with response containing the created content ID
 */
export function createPlanningWeekContent(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-week-content';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

/**
 * Updates an existing content entry
 * @param body_obj - Object with id and fields to update
 * @returns Promise with response containing updated content data
 */
export function updatePlanningWeekContent(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-week-content';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

/**
 * Deletes a content entry from a planning week
 * @param id - The content ID to delete
 * @returns Promise with deletion confirmation
 */
export function deletePlanningWeekContent(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-week-content/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

/**
 * ========================================
 * PLANNING WEEK PASTE FUNCTION
 * ========================================
 * Handles pasting (copying) all data from one week to another
 */

/**
 * Pastes all content from a source week to a destination week
 * This will delete all existing content in the destination week and replace it with the source week's data
 * @param body_obj - Object with season_id, team_id, source_week, destination_week
 * @returns Promise with response containing the updated destination week data
 */
export function pastePlanningWeek(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-week-paste';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

/**
 * Pastes all content from a source day to a destination day within the same week
 * This will delete all existing content in the destination day and replace it with the source day's data
 * @param body_obj - Object with season_id, team_id, week, source_day, destination_day
 * @returns Promise with response containing the updated destination day data
 */
export function pastePlanningDay(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-day-paste';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

/**
 * ========================================
 * PLANNING WEEK CLEAR FUNCTION
 * ========================================
 * Handles clearing/deleting all data from a week
 */

/**
 * Clears all content from a planning week
 * This will delete all days, races, content, and the week record itself
 * This operation is irreversible
 * @param body_obj - Object with season_id, team_id, week
 * @returns Promise with response containing deletion statistics
 */
export function clearPlanningWeek(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-week-clear';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

/**
 * ========================================
 * PLANNING PDF EXPORT FUNCTIONS
 * ========================================
 * These functions handle PDF export of planning data.
 */

/**
 * Exports a weekly planning to PDF
 * @param season - The season ID
 * @param team - The team ID
 * @param week - Week in format YYYY-WW (e.g., "2025-11")
 * @param chartImage - Optional chart image in base64 data URL format
 * @returns Promise with PDF data (base64 encoded)
 */
export function exportWeeklyPlanningPDF(season: number, team: number, week: string, chartImage?: string | null, weekName?: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-pdf';
    const params = [];
    if (season) {
        params.push('season=' + encodeURIComponent(season));
    }
    if (team) {
        params.push('team=' + encodeURIComponent(team));
    }
    if (week) {
        params.push('week=' + encodeURIComponent(week));
    }
    if (weekName) {
        params.push('week_name=' + encodeURIComponent(weekName));
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }

    // Prepare request body with chart image
    const body = {
        chart_image: chartImage || null
    };

    return axios.post(endpointUrl, JSON.stringify(body), { headers: headers });
}

/**
 * Exports annual planning to PDF
 * @param season - The season ID
 * @param team - The team ID
 * @param tableImage - Optional planning table image in base64 data URL format
 * @returns Promise with PDF data (base64 encoded)
 */
export function exportAnnualPlanningPDF(season: number, team: number, tableImage?: string | null) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/planning-annual-pdf';
    const params = [];
    if (season) {
        params.push('season=' + encodeURIComponent(season));
    }
    if (team) {
        params.push('team=' + encodeURIComponent(team));
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }

    // If table image is provided, send as POST with body
    if (tableImage) {
        const body = {
            table_image: tableImage
        };
        return axios.post(endpointUrl, JSON.stringify(body), { headers: headers });
    }

    // Otherwise, send as GET (backward compatible)
    return axios.get(endpointUrl, { headers: headers });
}

/**
 * Exports a monitoring session to PDF
 * @param monitoringId - The monitoring session ID
 * @param sessionImage - Captured image of the session details in base64 data URL format
 * @returns Promise with PDF data (base64 encoded)
 */
export type MonitoringSeriesImages = {
    summary: string | null;
    chart_shovelfuls: string | null;
    chart_laptimes: string | null;
};

export function exportMonitoringPDF(
    monitoringId: number,
    payload: MonitoringSeriesImages | { series: MonitoringSeriesImages[] }
) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/monitoring-pdf';
    if (monitoringId) {
        endpointUrl += '?monitoring_id=' + encodeURIComponent(monitoringId);
    }

    return axios.post(endpointUrl, JSON.stringify(payload), { headers: headers });
}